import { useTranslations } from 'next-intl';
import { CustomAccordion } from '@/components/ui/Accordion/CustomAccordion';
import { Link } from '@/i18n/routing';
import { cn } from '@/utils/cn';
import { LINKS } from '../data';

interface Props {
  className?: string;
  onAccordionChange?: (isOpen: boolean) => void;
}

const Links = ({ className, onAccordionChange }: Props) => {
  const t = useTranslations('footer');
  const columns = LINKS[0]?.links || [];

  return (
    <div className={className}>
      <div className="hidden xl:flex">
        <div className="grid grid-cols-3 w-full mr-29 3xl:mr-0 3xl:mt-1.5 gap-4.25 mt-0.25 3xl:gap-5.25">
          {columns.map((column, colIndex) => (
            <div key={colIndex} className={cn('flex flex-col gap-3 3xl:last:ml-0 last:ml-7.75')}>
              {column.map((link, linkIndex) =>
                link.onClick
                  ? (
                      <button
                        key={linkIndex}
                        type="button"
                        onClick={link.onClick}
                        className="text-white 3xl:paragraph-s-semibold paragraph-xs-medium hover:text-primary-2 duration-150 flex"
                      >
                        {t(`${link.label}`)}
                      </button>
                    )
                  : (
                      <Link
                        key={linkIndex}
                        href={link.href}
                        className="text-white 3xl:paragraph-s-semibold paragraph-xs-medium hover:text-primary-2 duration-150"
                      >
                        {t(`${link.label}`)}
                      </Link>
                    ),
              )}
            </div>
          ))}

        </div>

      </div>

      <CustomAccordion
        className="xl:hidden w-full flex flex-col gap-4 mt-8 paragraph-m-medium"
        contentClassName="pl-0 mt-[1.875rem] mb-2"
        triggerClassName="rounded-[3.125rem] pr-5 flex items-center"
        onValueChange={(value: string | string[]) => {
          const isOpen = Array.isArray(value) ? value.length > 0 : Boolean(value);
          onAccordionChange?.(isOpen);
        }}
        items={LINKS.map(link => ({
          value: t(`${link.title}`),
          trigger: t(`${link.title}`),
          content: (
            <div className="flex flex-col gap-4">
              {link.links.flat().map((linkItem, index) =>
                linkItem.onClick
                  ? (
                      <button
                        key={index}
                        type="button"
                        onClick={linkItem.onClick}
                        className="text-white paragraph-s-regular hover:text-primary-2 duration-150 flex"
                      >
                        {t(`${linkItem.label}`)}
                      </button>
                    )
                  : (
                      <Link
                        key={index}
                        href={linkItem.href}
                        className="text-white paragraph-s-regular hover:text-primary-2 duration-150"
                      >
                        {t(`${linkItem.label}`)}
                      </Link>
                    ),
              )}
            </div>
          ),
        }))}
      />
    </div>
  );
};

export default Links;
